// Central data-testid registry so tests and UI stay in sync.
export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  brand: "nav-brand",
  linkParlay: "nav-link-parlay",
  linkConverter: "nav-link-converter",
  linkHow: "nav-link-how-it-works",
  linkAbout: "nav-link-about",
  linkPlaybook: "nav-link-playbook",
  linkRoundRobin: "nav-link-round-robin",
  linkPropOdds: "nav-link-prop-odds",
  linkAnalyzer: "nav-link-analyzer",
  linkSponsors: "nav-link-sponsors",
  linkResponsible: "nav-link-responsible",
};

export const PARLAY = {
  card: "parlay-card",
  betInput: "parlay-bet-input",
  betError: "parlay-bet-error",
  addLeg: "parlay-add-leg",
  reset: "parlay-reset",
  copyResults: "parlay-copy-results",
  shareResults: "parlay-share-results",
  exampleBtn: "parlay-example-btn",
  leg: (i) => `parlay-leg-${i}`,
  legInput: (i) => `parlay-leg-input-${i}`,
  legError: (i) => `parlay-leg-error-${i}`,
  legRemove: (i) => `parlay-leg-remove-${i}`,
  resultCombinedAmerican: "parlay-result-combined-american",
  resultCombinedDecimal: "parlay-result-combined-decimal",
  resultImplied: "parlay-result-implied",
  resultProfit: "parlay-result-profit",
  resultPayout: "parlay-result-payout",
};

export const CONVERTER = {
  card: "converter-card",
  tabAmerican: "converter-tab-american",
  tabDecimal: "converter-tab-decimal",
  tabFractional: "converter-tab-fractional",
  inputAmerican: "converter-input-american",
  inputDecimal: "converter-input-decimal",
  inputFractional: "converter-input-fractional",
  inputError: "converter-input-error",
  copyResults: "converter-copy-results",
  shareResults: "converter-share-results",
  exampleBtn: "converter-example-btn",
  outAmerican: "converter-out-american",
  outDecimal: "converter-out-decimal",
  outFractional: "converter-out-fractional",
  outImplied: "converter-out-implied",
  outProfit: "converter-out-profit",
  outPayout: "converter-out-payout",
};

export const FOOTER = {
  root: "site-footer",
  linkAbout: "footer-link-about",
  linkSponsors: "footer-link-sponsors",
  linkPlaybook: "footer-link-playbook",
  linkPrivacy: "footer-link-privacy",
  linkTerms: "footer-link-terms",
  linkContact: "footer-link-contact",
  linkResponsible: "footer-link-responsible",
};

export const PLAYBOOK = {
  index: "playbook-index",
  search: "playbook-search",
  card: (slug) => `playbook-card-${slug}`,
  cardCta: (slug) => `playbook-card-cta-${slug}`,
  lesson: "playbook-lesson",
  quizOption: (qIdx, optIdx) => `playbook-quiz-${qIdx}-opt-${optIdx}`,
  quizResult: (qIdx) => `playbook-quiz-result-${qIdx}`,
  relatedTool: "playbook-related-tool",
  prev: "playbook-prev",
  next: "playbook-next",
  markComplete: "playbook-mark-complete",
  progressBar: "playbook-progress-bar",
  resetProgress: "playbook-reset-progress",
};
export const ROUND_ROBIN = {
  page: "round-robin-page",
  legsCount: "rr-legs-count",
  addLeg: "rr-add-leg",
  removeLeg: "rr-remove-leg",
  legInput: (i) => `rr-leg-input-${i}`,
  legError: (i) => `rr-leg-error-${i}`,
  legStatus: (i) => `rr-leg-status-${i}`,
  sizeToggle: (k) => `rr-size-toggle-${k}`,
  wagerModePer: "rr-wager-mode-per-combo",
  wagerModeBudget: "rr-wager-mode-total-budget",
  wagerInput: "rr-wager-input",
  wagerError: "rr-wager-error",
  reset: "rr-reset",
  calculate: "rr-calculate",
  totalCombos: "rr-total-combos",
  totalStake: "rr-total-stake",
  totalMaxReturn: "rr-total-max-return",
  totalMaxProfit: "rr-total-max-profit",
  settledReturn: "rr-settled-return",
  settledProfit: "rr-settled-profit",
  pendingMax: "rr-pending-max",
  overallStatus: "rr-overall-status",
  groupSection: (k) => `rr-group-${k}`,
  comboRow: (k, i) => `rr-combo-${k}-${i}`,
  comboStatus: (k, i) => `rr-combo-${k}-${i}-status`,
  comboReturn: (k, i) => `rr-combo-${k}-${i}-return`,
  copyResults: "rr-copy-results",
  shareResults: "rr-share-results",
};

export const SPONSORS = {
  page: "sponsors-page",
  grid: "sponsors-grid",
  card: (id) => `sponsor-card-${id}`,
  cover: (id) => `sponsor-cover-${id}`,
  cardLogo: (id) => `sponsor-card-logo-${id}`,
  cardLogoLink: (id) => `sponsor-card-logo-link-${id}`,
  cardVisit: (id) => `sponsor-card-visit-${id}`,
  disclaimer: "sponsors-disclaimer",
};

export const PROP_ODDS = {
  page: "prop-odds-page",
  loading: "prop-odds-loading",
  error: "prop-odds-error",
  empty: "prop-odds-empty",
  staleBanner: "prop-odds-stale-banner",
  cutoffBanner: "prop-odds-cutoff-banner",
  updatedLabel: "prop-odds-updated-label",
  todayLabel: "prop-odds-today-label",
  playerSearch: "prop-odds-player-search",
  sportHeading: "prop-odds-sport-mlb",
  gameAccordion: (evId) => `prop-odds-game-${evId}`,
  gameToggle: (evId) => `prop-odds-game-toggle-${evId}`,
  gamePanel: (evId) => `prop-odds-game-panel-${evId}`,
  categoryTab: (evId, statID) => `prop-odds-category-${evId}-${statID}`,
  playerRow: (evId, pid) => `prop-odds-player-${evId}-${pid}`,
  playerToggle: (evId, pid) => `prop-odds-player-toggle-${evId}-${pid}`,
  playerPanel: (evId, pid) => `prop-odds-player-panel-${evId}-${pid}`,
  bookOdds: (evId, pid, book) => `prop-odds-book-${evId}-${pid}-${book}`,
  bestBadge: (evId, pid, book) => `prop-odds-best-${evId}-${pid}-${book}`,
  deeplink: (evId, pid, book) => `prop-odds-deeplink-${evId}-${pid}-${book}`,
  noResults: "prop-odds-no-results",
};

